/**
 * Add animation class on scroll
 * Watches #main > * for visibility and adds
 * `.scrolled-into-view` class.
 */
const addIntersectionObservers = () => {
    const wrapper = document.getElementById('main');
    
    const elements = Array.from(wrapper.querySelectorAll('.should-animate'));

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: .5
    };

    const callback = (entries, observer) => {
        entries.forEach(({ isIntersecting, target }, i) => {
            if (isIntersecting) {
                // Add/remove classes and attributes, stop observing
                target.classList.add('animated');
                target.classList.remove('should-animate');

                observer.unobserve(target);
            }
        });
    };
      
    const observer = new IntersectionObserver(callback, options);
    elements.forEach(el => observer.observe(el));
};

module.exports = {
    addIntersectionObservers
};
